import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, take, switchMap } from 'rxjs/operators';

import { MenuComponent } from '../menu/menu.component';
import { ElofizetoCegService } from '../../../services/elofizeto-ceg.service';

@Component({
  selector: 'rendelo-shell',
  imports: [RouterOutlet, MenuComponent],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss'
})
export class ShellComponent implements OnInit {
  private authService = inject(AuthService);
  private elofizetoCegService = inject(ElofizetoCegService);
  private router = inject(Router);

  ngOnInit(): void {
    this.authService.isAuthenticated$.pipe(
      filter(isAuthenticated => isAuthenticated),
      take(1),
      switchMap(() => {
        if (this.elofizetoCegService.hasSelectedCeg()) {
          return [];
        }
        return this.elofizetoCegService.getElofizetoCegek();
      })
    ).subscribe({
      next: (cegek) => {
        if (!cegek || cegek.length === 0) {
          return;
        }

        if (cegek.length === 1) {
          this.elofizetoCegService.setSelectedCeg(cegek[0].uniqueId);
        } else {
          this.router.navigate(['/select-ceg']);
        }
      },
      error: (err) => {
        console.error('Error loading cegek:', err);
      }
    });
  }
}
